import React from "react";
import {Form} from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {format, parse} from "date-fns";

class DateFilter extends React.Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFilterDateStartChangeNative = this.handleFilterDateStartChangeNative.bind(this);
    this.handleFilterDateEndChangeNative = this.handleFilterDateEndChangeNative.bind(this);
  }


  handleInputChange(date, name) {
    this.props.handleInputChange(name, date);
  }

  handleFilterDateStartChangeNative(event) {
    let value = event.target.value;
    if (!value){ 
      this.props.handleInputChange('filterDateStart', null);
    } else {
      // Ensure we're parsing in local timezone
      const dateNew = parse(value, 'yyyy-MM-dd', new Date());
      
      // Validate the parsed date
      if (isNaN(dateNew.getTime())) {
        console.error('Invalid date parsed:', value);
        return;
      }
      
      this.props.handleInputChange('filterDateStart', dateNew);
    }
  }
  
  handleFilterDateEndChangeNative(event) {
    let value = event.target.value;
    if (!value){
      this.props.handleInputChange('filterDateEnd', null);
    } else {
      // Ensure we're parsing in local timezone
      const dateNew = parse(value, 'yyyy-MM-dd', new Date());
      
      // Validate the parsed date
      if (isNaN(dateNew.getTime())) {
        console.error('Invalid date parsed:', value);
        return;
      }
      
      this.props.handleInputChange('filterDateEnd', dateNew);
    }
  }
  
  componentDidMount() {
  }
  render() {
    const startDate = this.props.dateFilterStart;
    let formattedStartDateDisplay, 
      formattedEndDateDisplay;
    if (startDate) {
      formattedStartDateDisplay = format(startDate, "yyyy-MM-dd");
    } else {
      formattedStartDateDisplay = "";
    }
    const endDate = this.props.dateFilterEnd;
    if (endDate) {
      formattedEndDateDisplay = format(endDate, "yyyy-MM-dd");
    } else {
      formattedEndDateDisplay = "";
    }
    const width = this.props.width;
    const label = this.props.sortBy === 'Date Loaded' ? 'Filter by Load Date' : 'Filter by Order Date';

    return (
      <Form  className="date-filter">
        <Form.Group>     
        <Form.Label className="pt-2">{label}</Form.Label>
          {width <= 576 ? (
            <>
              <Form.Label>Start Date:</Form.Label>
              <Form.Control
                name="filterDateStart"
                type="date"
                dateFormat="dd/MM/yyyy"
                autoComplete="off"
                value={formattedStartDateDisplay}
                onChange={this.handleFilterDateStartChangeNative}
                placeholder="Date Start"
              />
              <Form.Label className="pt-2">End Date:</Form.Label>
              <Form.Control
                name="filterDateEnd"
                type="date"
                dateFormat="dd/MM/yyyy"
                autoComplete="off"
                value={formattedEndDateDisplay}
                onChange={this.handleFilterDateEndChangeNative}
                placeholder="Date End"
              />
            </>
          ) : (
            <>
              <Form.Label>Start Date:</Form.Label>
              <DatePicker
                name="filterDateStart"
                type="date"
                className="form-control block popover-select top"
                dateFormat="dd/MM/yyyy"
                placeholderText="Date Start"
                autoComplete="off"
                selected={this.props.dateFilterStart}
                onChange={(date) => this.handleInputChange(date, 'filterDateStart')}
              />
              <Form.Label className="pt-2">End Date:</Form.Label>
              <DatePicker
                name="filterDateEnd"
                type="date"
                className="form-control block popover-select bottom"
                dateFormat="dd/MM/yyyy"
                placeholderText="Date End"
                autoComplete="off"
                selected={this.props.dateFilterEnd}
                onChange={(date) => this.handleInputChange(date, 'filterDateEnd')}
              />
            </>
          )}
          {this.props.dateFilterEnd < this.props.dateFilterStart ? <p className="form-error-message">Invalid Date Range</p> : null}
        </Form.Group>
      </Form>
    );
  }
}

export default DateFilter;